import React, { Fragment } from "react"
import { makeStyles } from "@cirrus/ui-kit"
import classNames from "classnames"

import i18n from "@cirrus/legacy/features/core/shared/utils/i18n.es6"
import { Icon } from "@cirrus/legacy/app-components/entries/lib.js"
import { StatelessAlert, AlertType } from "@cirrus/ui-kit/AlertV1"
import { NotificationType } from "@cirrus/legacy/features/core/shared/constants/notification.js"

const useStyles = makeStyles({
  notification: {
    "& + &": { marginTop: "20px" },
  },

  alert: {
    padding: "15px",
  },

  alertPrefixText: {
    textTransform: "none !important",
    marginRight: "10px",
  },
})

const getAlertType = (type) => {
  switch (type) {
    case NotificationType.success:
      return AlertType.success

    case NotificationType.error:
      return AlertType.danger

    case NotificationType.warning:
      return AlertType.warning

    case NotificationType.info:
      return AlertType.info

    default:
      return null
  }
}

const useMessagePrefixStyles = makeStyles({
  icon: {
    marginRight: "10px",
  },
})

const MessagePrefix = ({ icon, text, textClassName }) => {
  const classes = useMessagePrefixStyles()

  return (
    <Fragment>
      <Icon icon={icon} className={classNames("fa-1-5x", classes.icon)} />
      <strong className={textClassName}>{text}</strong>
    </Fragment>
  )
}

const getMessagePrefixByType = (type, classes) => {
  switch (type) {
    case NotificationType.success:
      return (
        <MessagePrefix
          icon={"fa-check-circle"}
          text={`${i18n("General:Success").toLowerCase()}!`}
          textClassName={classes.alertPrefixText}
        />
      )

    case NotificationType.error:
      return (
        <MessagePrefix
          icon={"fa-times-circle"}
          text={`${i18n("General:Error").toLowerCase()}!`}
          textClassName={classes.alertPrefixText}
        />
      )

    case NotificationType.warning:
      return (
        <MessagePrefix
          icon={"fa-warning"}
          text={`${i18n("General:Alert").toLowerCase()}!`}
          textClassName={classes.alertPrefixText}
        />
      )

    case NotificationType.info:
      return (
        <MessagePrefix
          icon={"fa-info-circle"}
          text={`${i18n("General:Info").toLowerCase()}!`}
          textClassName={classes.alertPrefixText}
        />
      )

    default:
      null
  }
}

const Notification = ({ htmlEnabled, message, type, isHideEnabled, onHide }) => {
  const classes = useStyles()

  return (
    <div className={classes.notification}>
      <StatelessAlert
        noLayout={true}
        className={classes.alert}
        type={getAlertType(type)}
        isDismissable={isHideEnabled}
        onHide={onHide}>
        {getMessagePrefixByType(type, classes)}

        {htmlEnabled ? <div dangerouslySetInnerHTML={{ __html: message }} /> : message}
      </StatelessAlert>
    </div>
  )
}

export default Notification
